module.exports = __webpack_public_path__ + "static/media/10.e3a1f9e9.jpg";